import { ValidationRules } from '../../molecules/Form'

export const contactFormValidationsMap: ValidationRules = {
  acceptPrivacy: 'accepted',
  email: 'required|string|email',
  name: 'string|min:3',
  subject: 'string|min:3',
  message: 'required|string|min:3'
}
